<template>
    <div class="modal">
      <div class="modal-content">
        <h2>Success</h2>
        <p>Your request was successful. What would you like to do next?</p>
        <div class="button-group">
          <button @click.prevent="handleClickPo">
            <i class="fas fa-file-pdf"></i> Download PO
          </button>
          <button @click.prevent="handleClickSo">
            <i class="fas fa-file-pdf"></i> Download SO
          </button>
          <button @click.prevent="handleClick">
            <i class="fas fa-list"></i> Contract List
          </button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    methods: {
    handleClick() {
      this.$emit('goToContracts');
    },
    handleClickPo() {
      this.$emit('downloadPO');
    },
    handleClickSo() {
      this.$emit('downloadSO');
    }
  }
  };
  </script>
  
  <style scoped>
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    max-width: 500px; /* Ajustar el ancho máximo del modal */
    width: 100%; /* Ancho del modal en % */
  }
  
  .button-group {
    display: flex;
    justify-content: space-between;
    margin-top: 20px; /* Espacio entre el texto y los botones */
  }
  
  button {
    margin: 5px;
    padding: 10px 20px;
    background-color: #6985f5;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    flex: 1; /* Cada botón ocupará el mismo ancho */
    display: flex;
    align-items: center; /* Centrar verticalmente el ícono y el texto */
  }
  
  button i {
    margin-right: 5px; /* Espacio entre el ícono y el texto */
  }
  
  button:hover {
    background-color: #6985f5;
  }
  </style>
  